export default {
      id: "back-usage",
      viewBox: "0 0 240.823 240.823",
      url: "/assets/svg/" + "sprite.svg#back-usage",
      toString: function () {
        return this.url;
      }
    }